// extracted by mini-css-extract-plugin
export default {"textInput":"TextInput_textInput__VoMRK","input":"TextInput_input__BNb89"};